<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 80.879 80.879">
    <g transform="translate(-6 -6)">
      <path
        d="M43.283,46.03a1.555,1.555,0,0,0-1.975.98c-.109.342-.233.684-.373,1.011a1.555,1.555,0,0,0,.824,2.038,1.415,1.415,0,0,0,.607.124,1.555,1.555,0,0,0,1.431-.949c.171-.42.327-.824.467-1.229a1.555,1.555,0,0,0-.98-1.975Z"
        transform="translate(19.333 22.185)"
      />
      <path
        d="M48.118,35.317a20.1,20.1,0,0,0-6.081-14.449,1.562,1.562,0,0,0-2.178,2.24,16.891,16.891,0,0,1,5.148,12.21v9.674a45.107,45.107,0,0,1-1.555,11.836,1.555,1.555,0,0,0,1.1,1.913h.4a1.555,1.555,0,0,0,1.555-1.151,48.681,48.681,0,0,0,1.555-12.645Z"
        transform="translate(18.542 8.012)"
      />
      <path
        d="M17.989,56.819a1.555,1.555,0,0,0,1.1-.451l.9-.918A12.07,12.07,0,0,0,23.541,46.9V37.221a17.109,17.109,0,0,1,24.5-15.445,1.555,1.555,0,1,0,1.338-2.8A20.22,20.22,0,0,0,20.431,37.221V46.9a8.928,8.928,0,0,1-2.644,6.361l-.9.9a1.555,1.555,0,0,0,1.1,2.66Z"
        transform="translate(5.789 6.108)"
      />
      <path
        d="M44.42,33.555a1.555,1.555,0,1,0-3.111,0v5.008A39.724,39.724,0,0,1,35.088,60a1.553,1.553,0,1,0,2.613,1.68A42.788,42.788,0,0,0,44.42,38.564Z"
        transform="translate(16.018 14.44)"
      />
      <path
        d="M24.565,41.544a1.555,1.555,0,0,0,1.555-1.555V35.322A10.909,10.909,0,0,1,47.9,33.969a1.568,1.568,0,1,0,3.111-.4,14.026,14.026,0,0,0-28,1.758v4.666A1.555,1.555,0,0,0,24.565,41.544Z"
        transform="translate(9.431 8.007)"
      />
      <path
        d="M27.035,36a1.555,1.555,0,0,0-1.664,1.446,15.2,15.2,0,0,1-4.417,9.659l-1.882,1.96a1.555,1.555,0,1,0,2.209,2.178L23.224,49.3A18.307,18.307,0,0,0,28.59,37.666,1.555,1.555,0,0,0,27.035,36Z"
        transform="translate(6.962 16.66)"
      />
      <path
        d="M39.1,40.011a1.555,1.555,0,0,0-1.835,1.213,33.565,33.565,0,0,1-7.295,14.854A1.555,1.555,0,1,0,32.337,58.1a36.784,36.784,0,0,0,7.979-16.238A1.555,1.555,0,0,0,39.1,40.011Z"
        transform="translate(13.107 18.871)"
      />
      <path
        d="M32.5,32.777a4.666,4.666,0,1,1,9.332,0V43.54a1.56,1.56,0,0,0,3.111.249V32.777a7.777,7.777,0,1,0-15.554,0v9.674a21.231,21.231,0,0,1-6.221,15.212,1.562,1.562,0,1,0,2.209,2.209A24.4,24.4,0,0,0,32.5,42.451Z"
        transform="translate(9.277 10.552)"
      />
      <path
        d="M27.292,48.042c-.42.5-.871.964-1.338,1.431a1.562,1.562,0,1,0,2.209,2.209c.529-.529,1.011-1.058,1.555-1.555A1.555,1.555,0,0,0,27.354,48.1Z"
        transform="translate(10.827 23.081)"
      />
      <path
        d="M31.028,56.515A30.641,30.641,0,0,0,35.695,40.23V30.555a1.555,1.555,0,1,0-3.111,0V40.23a27.468,27.468,0,0,1-4.2,14.636,1.558,1.558,0,0,0,2.644,1.649Z"
        transform="translate(12.3 12.774)"
      />
      <path
        d="M18.812,25.762a1.555,1.555,0,0,0,2.193-.311,23.331,23.331,0,0,1,42,14v7.777a1.555,1.555,0,1,0,3.111,0V39.449A26.441,26.441,0,0,0,18.5,23.585,1.555,1.555,0,0,0,18.812,25.762Z"
        transform="translate(6.77 3.88)"
      />
      <path
        d="M18.111,33.927a23.533,23.533,0,0,1,1.789-8.99,1.555,1.555,0,0,0-2.862-1.182A26.224,26.224,0,0,0,15,33.927V41.7a1.555,1.555,0,1,0,3.111,0Z"
        transform="translate(4.998 9.402)"
      />
      <path
        d="M7.555,26.22a1.555,1.555,0,0,0,1.555-1.555V9.111H24.664a1.555,1.555,0,0,0,0-3.111H7.555A1.555,1.555,0,0,0,6,7.555V24.664A1.555,1.555,0,0,0,7.555,26.22Z"
        transform="translate(0 0)"
      />
      <path
        d="M63.664,6H46.555a1.555,1.555,0,1,0,0,3.111H62.109V24.664a1.555,1.555,0,0,0,3.111,0V7.555A1.555,1.555,0,0,0,63.664,6Z"
        transform="translate(21.66 0)"
      />
      <path
        d="M63.664,45a1.555,1.555,0,0,0-1.555,1.555V62.109H46.555a1.555,1.555,0,1,0,0,3.111H63.664a1.555,1.555,0,0,0,1.555-1.555V46.555A1.555,1.555,0,0,0,63.664,45Z"
        transform="translate(21.66 21.66)"
      />
      <path
        d="M24.664,62.109H9.111V46.555a1.555,1.555,0,1,0-3.111,0V63.664A1.555,1.555,0,0,0,7.555,65.22H24.664a1.555,1.555,0,0,0,0-3.111Z"
        transform="translate(0 21.66)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4FingerPrintSvg"
};
</script>
